import { ACTION_TYPE, REPORT_NAME } from "../../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { Modal } from "react-bootstrap";
import { useFindAllLibraryCategoriesMutation, useGetLibraryCategoryByIdMutation, useSaveLibraryCategoryMutation, useUpdateLibraryCategoryMutation } from "../../redux-toolkit/services/libraryCategoriesService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { getAllLibraryCategoriesDetails, setAllLibraryCategories } from "../../redux-toolkit/slices/libraryCategorySlice";
import { useUploadPdfMutation } from "../../redux-toolkit/services/privateLibraryService";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
};

const PrivateLibraryData = (props: Props) => {

    const localUserObj: any = getLocalStorageData("localUser");
    const dispatch = useDispatch();
    const token: any = getLocalStorageData("localUser").token;

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);

    //save
    const [saveLibraryCategory, saveLibraryCategoryResponse] = useSaveLibraryCategoryMutation();
    const [uploadPdf, uploadPdfResponse] = useUploadPdfMutation();

    //update
    const [updateLibraryCategory, updateLibraryCategoryResponse] = useUpdateLibraryCategoryMutation();

    //getById mutation
    const [getLibraryCategoryById, libraryCategoryByIdResponse] = useGetLibraryCategoryByIdMutation();

    //getData
    const [findAllLibraryCategory, findAllLibraryCategoryResponse] = useFindAllLibraryCategoriesMutation();

    const allCategoriesData = useAppSelector(getAllLibraryCategoriesDetails);

    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.LIBRARY_CATEGORY) {
                getLibraryCategoryById({
                    id: props?.data?.id,
                });
            }
        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.LIBRARY) {
                findAllLibraryCategory({})
            }
        }
    }, [props.reportName]);

    useEffect(() => {
        if (libraryCategoryByIdResponse.isSuccess) {
            setGetByIdData(libraryCategoryByIdResponse.data)
        } else if (libraryCategoryByIdResponse.isError) {
            let response: any = libraryCategoryByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [libraryCategoryByIdResponse.isSuccess, libraryCategoryByIdResponse.isError]);

    const handleClose = () => {
        props.setShow(false);
    };

    const handleSubmit = (values: any) => {

        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.LIBRARY_CATEGORY) {
                saveLibraryCategory({
                    payload: {
                        name: values.name,
                    },
                });
            } else if (props.reportName === REPORT_NAME.LIBRARY) {
                const formData = new FormData();
                formData.append('file', file);

                uploadPdf({
                    libraryCategoryId: values.libraryCategoryId,
                    file: formData
                });
            }
        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.LIBRARY_CATEGORY) {
                updateLibraryCategory({
                    id: props.data.id,
                    payload: {
                        isActive: props.data.isActive,
                        id: props.data.id,
                        name: values.name,
                    },
                });
            }
        }
    };

    // upload file...............................
    const fileHandler = (e: any) => {

        const file = e.target.files[0];

        const fileName = e.target.files[0].name;
        // setFileName(fileName)
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "pdf" || extFile == "zip") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only pdf and zip files are allowed!", "error");
        }
    };

    useEffect(() => {
        if (saveLibraryCategoryResponse.isSuccess) {
            alertMessage("Library Category added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveLibraryCategoryResponse.isError) {
            let response: any = saveLibraryCategoryResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveLibraryCategoryResponse.isSuccess, saveLibraryCategoryResponse.isError]);

    useEffect(() => {
        if (updateLibraryCategoryResponse.isSuccess) {
            alertMessage("Library Category updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateLibraryCategoryResponse.isError) {
            let response: any = updateLibraryCategoryResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateLibraryCategoryResponse.isSuccess, updateLibraryCategoryResponse.isError]);

    useEffect(() => {
        if (findAllLibraryCategoryResponse.isSuccess) {
            console.log(findAllLibraryCategoryResponse)

            dispatch(setAllLibraryCategories(findAllLibraryCategoryResponse.data));
        } else if (findAllLibraryCategoryResponse.isError) {
            let response: any = findAllLibraryCategoryResponse?.error;
            alertMessage(response, "error");
        }
    }, [findAllLibraryCategoryResponse.isSuccess, findAllLibraryCategoryResponse.isError]);

    useEffect(() => {
        if (uploadPdfResponse.isSuccess) {
            alertMessage("Uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (uploadPdfResponse.isError) {
            let response: any = uploadPdfResponse?.error;
            alertMessage(response, "error");
        }
    }, [uploadPdfResponse.isSuccess, uploadPdfResponse.isError]);

    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            // style={{ marginTop: '20rem' }}
            // className={props.reportName === REPORT_NAME.TIME_SHEET ? "modal-xl" : "modal-lg"}
            // dialogClassName={"modal-90w"}
            >
                <Modal.Header closeButton>
                    <Modal.Title
                        className="fw-bold text-primary"
                        style={{ fontSize: "1rem" }}
                    >
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Formik
                        validateOnChange={true}
                        validateOnBlur={true}
                        enableReinitialize={true}
                        initialValues={props.reportName === REPORT_NAME.LIBRARY_CATEGORY
                            ? {
                                name:
                                    props.actionType === ACTION_TYPE.UPDATE_ACTION
                                        ? getByIdData && getByIdData.name
                                        : "",
                            } : {
                                libraryCategoryId:
                                    props.actionType === ACTION_TYPE.UPDATE_ACTION
                                        ? getByIdData && getByIdData.libraryCategoryId
                                        : "",
                                file:
                                    props.actionType === ACTION_TYPE.UPDATE_ACTION
                                        ? getByIdData && getByIdData.fileData
                                        : "",
                            }}
                        onSubmit={handleSubmit}
                    >
                        {({ values, handleChange, setFieldValue, errors, touched, handleBlur }) => (
                            <Form>
                                {props.reportName === REPORT_NAME.LIBRARY_CATEGORY ? (
                                    <div>
                                        <p>
                                            Name
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.name}
                                                name="name"
                                            />
                                        </p>
                                    </div>
                                ) : (
                                    <div>
                                        <div>
                                            <div className="d-flex">
                                                <div>Library Category</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <div className="w-100">
                                                <div className="pe-2">
                                                    <select
                                                        className="form-select form-select-sm w-100"
                                                        aria-label=".form-select-sm example"
                                                        onChange={handleChange}
                                                        name="libraryCategoryId"
                                                        value={values.libraryCategoryId}
                                                        required
                                                    >
                                                        <option value="">
                                                            Select Library Category
                                                        </option>
                                                        {allCategoriesData &&
                                                            allCategoriesData.map((itemType: any, index: any) => {
                                                                return (
                                                                    <option
                                                                        key={index.toString()}
                                                                        value={itemType.id}
                                                                    >
                                                                        {itemType.id} - {itemType.name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-2">
                                            <div className="d-flex">
                                                <div>Upload File</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                type="file"
                                                id="fileUpload"
                                                className="ms-2"
                                                onChange={(e: any) => {
                                                    fileHandler(e);
                                                    setFieldValue("file", e.target.files[0]);
                                                }}
                                                required
                                            />
                                            <hr />
                                        </div>
                                    </div>
                                )}
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        type="submit"
                                        className={`btn btn-primary btn-block mt-3 mx-2 btn-width`}
                                    >
                                        {props.actionType === ACTION_TYPE.ADD_ACTION
                                            ? "Save"
                                            : "Update"}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                        onClick={handleClose}
                                    >
                                        Close
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal >
        </>
    );

};

export default PrivateLibraryData